import { useMemo } from "react";

const blockTags = new Set(["P", "DIV", "H1", "H2", "H3", "H4", "H5", "H6", "LI", "TR"]);
const excludedTags = new Set(["SCRIPT", "STYLE", "IFRAME", "OBJECT", "TEMPLATE", "NOSCRIPT"]);

function messageText(node) {
  if (node.nodeType === 3) return node.textContent;
  if (excludedTags.has(node.nodeName)) return "";
  if (node.nodeName === "BR") return "\n";
  const text = Array.from(node.childNodes, messageText).join("");
  return blockTags.has(node.nodeName) ? `\n\n${text.trim()}\n\n` : text;
}

export default function NoteEmailPreview({ html, title }) {
  const paragraphs = useMemo(() => {
    const email = new DOMParser().parseFromString(html, "text/html");
    return messageText(email.body).trim().split(/\n\s*\n/).filter(Boolean);
  }, [html]);

  // Render text only so email markup cannot execute or override the app theme.
  return (
    <div className="note-email-body-preview" role="region" aria-label={title} tabIndex={0}>
      {paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
    </div>
  );
}
